import { combineLoaders } from '@/lib/loader/combine-loader';
import { permissionsLoader } from '@/lib/loader/permission-loader';
import { lazy } from 'react';
import { FeatureFlagKey } from '@/features/feature-flag/feature-flag.constants';
import { withFeature } from '@/features/feature-flag/components/with-feature';

const ResourcePage = lazy(() => import('./pages/resource'));
const ResourceFormPage = lazy(() => import('./pages/resource/form'));

const ActivityPage = lazy(() => import('./pages/activity'));
const ActivityFormPage = lazy(() => import('./pages/activity/form'));

// const CategoryPage = lazy(() => import('./pages/category/index'));
// const CategoryFormPage = lazy(() => import('./pages/category/form'));
const SmartSuggestionPage = lazy(() => import('./pages/smart-suggestion'));
const SmartSuggestionFilterFormPage = lazy(
  () => import('./pages/smart-suggestion/filters-form')
);
const AlternativeActivityFormPage = lazy(
  () => import('./pages/smart-suggestion/alternative-activity-form')
);
const CombiDealFormPage = lazy(
  () => import('./pages/smart-suggestion/combi-deal-form')
);

const AddonPage = lazy(() => import('./pages/add-on'));
const AddonFormPage = lazy(() => import('./pages/add-on/form'));

const FoodAndBeveragePage = lazy(() => import('./pages/food-and-beverage'));
const FoodAndBeverageFormPage = lazy(
  () => import('./pages/food-and-beverage/form')
);

export const inventoryRoute = [
  {
    path: '/inventory/resources',
    Component: ResourcePage,
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/inventory/resources/form',
    Component: ResourceFormPage,
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/inventory/resources/form/:id',
    Component: ResourceFormPage,
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/inventory/activities',
    Component: ActivityPage,
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/inventory/activities/form',
    Component: ActivityFormPage,
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/inventory/activities/form/:id',
    Component: ActivityFormPage,
    loader: combineLoaders(permissionsLoader),
  },

  // {
  //   path: '/inventory/categories',
  //   Component: CategoryPage,
  //   loader: combineLoaders(permissionsLoader),
  // },
  // {
  //   path: '/inventory/categories/form',
  //   Component: CategoryFormPage,
  //   loader: combineLoaders(permissionsLoader),
  // },
  // {
  //   path: '/inventory/categories/form/:id',
  //   Component: CategoryFormPage,
  //   loader: combineLoaders(permissionsLoader),
  // },

  {
    path: '/inventory/smart-suggestion',
    Component: withFeature(
      FeatureFlagKey.MODULE_SMART_SUGGESTION,
      SmartSuggestionPage
    ),
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/inventory/smart-suggestion/filters/form',
    Component: withFeature(
      FeatureFlagKey.MODULE_SMART_SUGGESTION,
      SmartSuggestionFilterFormPage
    ),
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/inventory/smart-suggestion/filters/form/:id',
    Component: withFeature(
      FeatureFlagKey.MODULE_SMART_SUGGESTION,
      SmartSuggestionFilterFormPage
    ),
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/inventory/smart-suggestion/alternative-activities/form',
    Component: withFeature(
      FeatureFlagKey.MODULE_SMART_SUGGESTION,
      AlternativeActivityFormPage
    ),
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/inventory/smart-suggestion/alternative-activities/form/:id',
    Component: withFeature(
      FeatureFlagKey.MODULE_SMART_SUGGESTION,
      AlternativeActivityFormPage
    ),
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/inventory/smart-suggestion/combi-deals/form',
    Component: withFeature(
      FeatureFlagKey.MODULE_SMART_SUGGESTION,
      CombiDealFormPage
    ),
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/inventory/smart-suggestion/combi-deals/form/:id',
    Component: withFeature(
      FeatureFlagKey.MODULE_SMART_SUGGESTION,
      CombiDealFormPage
    ),
    loader: combineLoaders(permissionsLoader),
  },

  {
    path: '/inventory/add-ons',
    Component: withFeature(FeatureFlagKey.MODULE_ADD_ONS, AddonPage),
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/inventory/add-ons/form',
    Component: withFeature(FeatureFlagKey.MODULE_ADD_ONS, AddonFormPage),
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/inventory/add-ons/form/:id',
    Component: withFeature(FeatureFlagKey.MODULE_ADD_ONS, AddonFormPage),
    loader: combineLoaders(permissionsLoader),
  },

  {
    path: '/inventory/food-and-beverage',
    Component: withFeature(
      FeatureFlagKey.MODULE_FOOD_AND_BEVERAGE,
      FoodAndBeveragePage
    ),
    loloader: combineLoaders(permissionsLoader),
  },
  {
    path: '/inventory/food-and-beverage/form',
    Component: withFeature(
      FeatureFlagKey.MODULE_FOOD_AND_BEVERAGE,
      FoodAndBeverageFormPage
    ),
    loloader: combineLoaders(permissionsLoader),
  },
  {
    path: '/inventory/food-and-beverage/form/:id',
    Component: withFeature(
      FeatureFlagKey.MODULE_FOOD_AND_BEVERAGE,
      FoodAndBeverageFormPage
    ),
    loloader: combineLoaders(permissionsLoader),
  },
];
